var render, staticRenderFns
import script from "./BaseSplitter.vue?vue&type=script&lang=js&"
export * from "./BaseSplitter.vue?vue&type=script&lang=js&"
import style0 from "./BaseSplitter.vue?vue&type=style&index=0&id=1e98a2bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports